// extracted by mini-css-extract-plugin
export default {"range":"Resources_range__gTTqh","easy":"Resources_easy__xGrHp"};